// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1257":"89107e6f","4581":"1eb9f8c2","5808":"46486df8","6053":"b77a7809","7462":"89107e6f"}[chunkId] + ".chunk.css";
};